import axios from "../utils/axios";

const API_URL = "/api/support";

// Create Ticket
export const createSupportApi = async (payload) => {
  const { data } = await axios.post(`${API_URL}/create`, payload);
  return data;
};

// Reply Ticket
export const replySupportApi = async (ticketId, payload) => {
  const { data } = await axios.post(`${API_URL}/reply/${ticketId}`, payload);
  return data;
};

// Get Restaurant Tickets
export const getRestaurantTicketsApi = async (restaurantId) => {
  const { data } = await axios.get(`${API_URL}/restaurant/${restaurantId}`);
  return data;
};

// Update Ticket Status
export const updateTicketStatusApi = async (ticketId, payload) => {
  const { data } = await axios.put(`${API_URL}/status/${ticketId}`, payload);
  return data;
};